import { getEntityRef } from "@client/content/lib/helper";
import {
  enterLesson,
  leaveLesson,
  quizBack,
  quizProceed,
  quizReview,
  quizReviewEnd,
  setActiveLessonId,
  startQuiz
} from "@client/content/modules/CourseDetail/actions";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { localStateSelector, makeActiveLessonSelector } from "../../../selectors";
import LessonComponent, { type ActionProps, type MapProps } from "./component";
import { makeNextLessonIdSelector, makePreviousLessonIdSelector } from "./selectors";

const makeMapStateToProps = () => {
  const activeItemSelector = makeActiveLessonSelector();
  const apiInfoSelector = makeModuleApiInfoSelector();
  const previousLessonIdSelector = makePreviousLessonIdSelector();
  const nextLessonIdSelector = makeNextLessonIdSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    const item = activeItemSelector(state, props)!;
    return {
      ...props,
      allFaq: localState.activeCourse!.allFaq,
      apiInfo: apiInfoSelector(state, props),

      data: item ? localState.lessonDetail[item.id] : null,
      lessonId: item?.id,
      courseId: localState.activeCourseId!,
      previousLessonId: previousLessonIdSelector(state, props),
      nextLessonId: nextLessonIdSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  enter: (courseId: string, lessonId: string) => dispatch(enterLesson(getEntityRef(props), courseId, lessonId)),
  leave: (courseId: string, lessonId: string) => dispatch(leaveLesson(getEntityRef(props), courseId, lessonId)),
  onArrowClick: (lessonId: string) => dispatch(setActiveLessonId({ ...getEntityRef(props), lessonId })),

  quizProceed: (lessonId: string, questionId: string, answerIds: string[]) =>
    dispatch(quizProceed({ ...getEntityRef(props), lessonId, questionId, answerIds })),
  quizBack: (lessonId: string) => dispatch(quizBack({ ...getEntityRef(props), lessonId })),
  quizReviewEnd: (lessonId: string) => dispatch(quizReviewEnd(getEntityRef(props), lessonId)),
  quizStart: (lessonId: string) => dispatch(startQuiz(getEntityRef(props), lessonId)),
  quizReview: (lessonId: string) => dispatch(quizReview({ ...getEntityRef(props), lessonId: lessonId }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(LessonComponent);
